import { render, staticRenderFns } from "./CoordinatePicker.vue?vue&type=template&id=c4c34904"
import script from "./CoordinatePicker.vue?vue&type=script&lang=js"
export * from "./CoordinatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports